import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-five-two-six',
  templateUrl: './two-five-two-six.component.html',
  styleUrls: ['./two-five-two-six.component.scss']
})
export class TwoFiveTwoSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
